var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeviceStopped01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#030104;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M330,191.9H197.2c-3.1,0-5.5,2.5-5.5,5.5v132.7c0,3,2.5,5.5,5.5,5.5H330c3,0,5.5-2.5,5.5-5.5V197.3 C335.5,194.3,333,191.9,330,191.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,16C123.5,16,16,123.4,16,256s107.5,240,240,240c132.6,0,240-107.4,240-240S388.6,16,256,16z M256,455.9 c-110.4,0-199.9-89.5-199.9-199.9c0-110.4,89.5-200,199.9-200c110.4,0,199.9,89.5,199.9,200C455.9,366.4,366.4,455.9,256,455.9z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceStopped01);
export default __webpack_public_path__ + "static/media/deviceStopped-01.fbcc81a121f85e9905b0e8dfd801245e.svg";
export { ForwardRef as ReactComponent };